import { render, staticRenderFns } from "./ReadabilitySeoRate.vue?vue&type=template&id=1f7a697a"
import script from "./ReadabilitySeoRate.vue?vue&type=script&lang=js"
export * from "./ReadabilitySeoRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports